import { CodeEditor, type PinnedRange } from "../CodeEditor";
import type { FileSelection } from "./types";

type Props = {
  output: string;
  fileName?: string;
  selectedRanges?: readonly PinnedRange[];
  onSelect?: (selections: FileSelection[]) => void;
};

export function Plain({ output, fileName, selectedRanges, onSelect }: Props) {
  return (
    <CodeEditor
      filePath={fileName ?? "output.txt"}
      value={output}
      onSelectionChange={
        onSelect &&
        ((selections) =>
          onSelect(
            selections.map((s) => ({
              from: s.from,
              to: s.to,
              fromLine: s.fromLine,
              toLine: s.toLine,
              text: s.text,
            }))
          ))
      }
      pinnedRanges={selectedRanges}
    />
  );
}
